export const hu = {
  app: {
    title: 'AppTransfer',
  },
  auth: {
    heroTitle: 'Buildek átadása, letöltésnaplóval.',
    heroText:
      'Töltse fel az új verziót, az érintettek e-mailt kapnak, és mindig látja, ki mikor töltötte le — akár PDF igazolással.',
    inviteOnly: 'Csak meghívott felhasználóknak.',
    signInTitle: 'Bejelentkezés',
    signInText: 'Lépjen be azzal a fiókkal, amelyre a meghívót kapta.',
    signIn: 'Bejelentkezés',
    signInWithGoogle: 'Folytatás Google-fiókkal',
    orWithEmail: 'vagy e-mail címmel',
    email: 'E-mail cím',
    password: 'Jelszó',
    newPassword: 'Jelszó megadása',
    passwordHint: 'Legalább 8 karakter.',
    name: 'Név',
    forgotPassword: 'Elfelejtett jelszó',
    gotInvite: 'Meghívót kapott, de még nincs jelszava?',
    activateLink: 'Fiók aktiválása',
    activateTitle: 'Fiók aktiválása',
    activateText:
      'Ha egy projektbe meghívták, itt állíthat be jelszót. Google-fiókkal rendelkező címnél egyszerűbb a Google-bejelentkezés.',
    activateEmailHint: 'Pontosan az a cím, amelyre a meghívó érkezett.',
    activateButton: 'Fiók aktiválása',
    activated: 'Fiók létrehozva. Küldtünk egy megerősítő e-mailt.',
    resetTitle: 'Új jelszó kérése',
    resetText: 'Megadott címére küldünk egy linket, amellyel új jelszót állíthat be.',
    sendResetLink: 'Link küldése',
    resetSent: 'Ha a(z) {email} címhez tartozik fiók, néhány percen belül megérkezik a link.',
    backToSignIn: 'Vissza a bejelentkezéshez',
    signOut: 'Kijelentkezés',
    errors: {
      invalidCredentials: 'Hibás e-mail cím vagy jelszó.',
      notInvited: 'Ez az e-mail cím nincs meghívva. Kérjen meghívót a projekt tulajdonosától.',
      emailInUse: 'Ehhez a címhez már tartozik fiók. Jelentkezzen be, vagy kérjen új jelszót.',
      weakPassword: 'A jelszó túl gyenge. Legalább 8 karakter legyen.',
      tooManyRequests: 'Túl sok próbálkozás. Várjon néhány percet, majd próbálja újra.',
      popupBlocked: 'A böngésző letiltotta a Google-ablakot. Engedélyezze a felugró ablakokat ennél az oldalnál.',
      network: 'Nincs kapcsolat a szerverrel. Ellenőrizze az internetkapcsolatot.',
      generic: 'A bejelentkezés nem sikerült. Próbálja újra.',
    },
  },
  access: {
    deniedTitle: 'Ehhez a fiókhoz nincs hozzáférés',
    deniedText:
      'A(z) {email} cím nincs a meghívottak között. Ha meghívást vár, kérje meg a projekt tulajdonosát, hogy vegye fel tagnak, vagy jelentkezzen be azzal a címmel, amelyre a meghívó érkezett.',
    checkAgain: 'Újraellenőrzés',
    unverifiedTitle: 'Erősítse meg az e-mail címét',
    unverifiedText:
      'Küldtünk egy megerősítő linket a(z) {email} címre. Kattintson rá, majd térjen vissza ide.',
    iVerified: 'Megerősítettem',
    resend: 'Link újraküldése',
    verificationSent: 'Új megerősítő linket küldtünk: {email}',
    maintenanceTitle: 'Karbantartás',
    maintenanceText: 'Az AppTransfer jelenleg karbantartás miatt nem érhető el. Próbálja újra később.',
    useOtherAccount: 'Bejelentkezés másik fiókkal',
    admin: {
      title: 'Hozzáférések',
      subtitle:
        'Csak az itt szereplő címek használhatják az alkalmazást. A projekt tulajdonosai is meghívhatnak, amikor tagot adnak hozzá.',
      loadFailed: 'A hozzáférések betöltése nem sikerült. Frissítse az oldalt.',
      migrationTitle: 'Meglévő felhasználók átvétele',
      migrationText:
        'A biztonsági frissítés óta csak meghívott címek léphetnek be. {count} meglévő fióknak még nincs meghívása. Az átvétel meghívja a projektek tulajdonosait és tagjait, és átalakítja a régi tag- és megosztási adatokat. Ismételten futtatható.',
      migrationButton: 'Átvétel indítása',
      migrated:
        'Kész: {invited} cím meghívva, {membersMigrated} tag és {shareLinksMigrated} megosztási link átalakítva.',
      migrationFailed: 'Az átvétel megszakadt. Futtassa újra; a már elkészült részeket nem duplázza.',
      inviteTitle: 'Meghívás',
      inviteText:
        'A meghívott Google-fiókkal azonnal beléphet, más címmel a „Fiók aktiválása” linken állíthat be jelszót.',
      inviteButton: 'Meghívás',
      invalidEmail: 'Adjon meg érvényes e-mail címet.',
      invited: '{email} meghívva',
      people: 'Személyek',
      search: 'Keresés név vagy e-mail alapján',
      empty: 'Nincs találat',
      you: 'Ön',
      invitedOn: 'meghívva {date}',
      lastLogin: 'utoljára belépett {date}',
      status: {
        admin: 'Admin',
        active: 'Aktív',
        invited: 'Meghívva',
        noAccess: 'Nincs hozzáférése',
      },
      grant: 'Hozzáférés megadása',
      revoke: 'Hozzáférés visszavonása',
      revokeTitle: 'Hozzáférés visszavonása',
      revokeText:
        '{email} azonnal elveszíti a hozzáférést minden projekthez. A projekttagságai megmaradnak, így újrameghívással visszakapja őket.',
      revoked: '{email} hozzáférése visszavonva',
      makeAdmin: 'Adminná tétel',
      makeAdminTitle: 'Admin jog megadása',
      makeAdminText: '{email} minden projektet láthat és kezelhet, és hozzáféréseket oszthat ki.',
      madeAdmin: 'Admin jog megadva',
      removeAdmin: 'Admin jog elvétele',
      removeAdminTitle: 'Admin jog elvétele',
      removeAdminText: '{email} ezután csak a saját és a megosztott projektjeit látja.',
      removedAdmin: 'Admin jog elvéve',
    },
  },
  nav: {
    main: 'Fő navigáció',
    menu: 'Menü',
    account: 'Fiók',
    dashboard: 'Áttekintés',
    projects: 'Projektek',
    access: 'Hozzáférések',
    settings: 'Beállítások',
    darkMode: 'Sötét téma',
    lightMode: 'Világos téma',
  },
  dashboard: {
    title: 'Áttekintés',
    greeting: 'Üdv, {name}!',
    subtitle: 'A legutóbbi kiadások és letöltések a projektjeiben.',
    stats: {
      projects: 'Projektek',
      projectsNote: 'ebből {owned} saját',
      releases: 'Kiadások',
      releasesNote: 'összesen',
      downloads: 'Letöltések',
      downloadsNote: 'saját projektekben',
    },
    recentReleases: 'Legutóbbi kiadások',
    noReleases: 'Még nincs kiadás',
    noReleasesText: 'Amint valaki feltölt egy verziót az Ön projektjeibe, itt jelenik meg.',
    favorites: 'Kedvencek',
    recentProjects: 'Legutóbbi projektek',
    viewAll: 'Összes',
    noProjects: 'Még nincs projektje',
    noProjectsText: 'Hozzon létre egyet, vagy várja meg, amíg valaki hozzáadja egy projekthez.',
    recentDownloads: 'Legutóbbi letöltések',
  },
  projects: {
    title: 'Projektek',
    subtitle: 'A saját és a megosztott projektjei.',
    adminSubtitle: 'Adminként minden projektet lát.',
    new: 'Új projekt',
    create: 'Projekt létrehozása',
    created: 'Projekt létrehozva',
    createFailed: 'A projekt létrehozása nem sikerült. Próbálja újra.',
    loadFailed: 'A projektek betöltése nem sikerült.',
    name: 'Projekt neve',
    description: 'Leírás',
    descriptionHint: 'A megosztási linket megnyitók is látják.',
    noDescription: 'Nincs leírás',
    search: 'Keresés a projektek között',
    filterByStatus: 'Szűrés állapot szerint',
    favoritesOnly: 'Kedvencek',
    favorite: 'Kedvencnek jelölés',
    unfavorite: 'Eltávolítás a kedvencek közül',
    allProjects: 'Összes projekt',
    mine: 'Saját projektek',
    sharedWithMe: 'Velem megosztott',
    empty: 'Még nincs projekt',
    emptyText: 'Egy projektbe töltheti fel az alkalmazás verzióit, és itt adhat hozzá tagokat, akik letölthetik őket.',
    noMatch: 'Nincs a szűrésnek megfelelő projekt.',
    updated: 'Frissítve: {date}',
    status: {
      all: 'Mind',
      active: 'Aktív',
      archived: 'Archivált',
      deleted: 'Törölt',
    },
  },
  projectDetail: {
    tabs: {
      releases: 'Kiadások',
      members: 'Tagok',
      sharing: 'Megosztás',
      settings: 'Beállítások',
    },
    memberView: 'Tagként látja',
    notFound: 'A projekt nem található',
    notFoundText: 'Lehet, hogy törölték, vagy nincs hozzá hozzáférése.',
    loadFailed: 'A projekt betöltése nem sikerült',
    backToProjects: 'Vissza a projektekhez',
    inactiveNotice: {
      archived: 'Ez a projekt archivált. Új kiadás és tag nem adható hozzá, a megosztási linkek nem működnek.',
      deleted: 'Ez a projekt töröltként van jelölve. A tagok nem látják, a megosztási linkek nem működnek.',
    },
    editDetails: 'Név és leírás',
    editDetailsText: 'A projekt neve és leírása a tagoknak és a megosztási oldalon is megjelenik.',
    saved: 'Projekt mentve',
    archive: 'Archiválás',
    archiveText: 'Elrejti az aktív projektek közül. A kiadások megmaradnak, később visszaállítható.',
    restore: 'Visszaállítás',
    restoreText: 'Ismét aktív lesz, a tagok újra elérik.',
    delete: 'Projekt törlése',
    deleteText: 'Töröltként jelöli meg. Adminként később visszaállítható.',
    confirm: {
      archived: {
        title: 'Projekt archiválása',
        text: 'Az archivált projektbe nem tölthető fel új kiadás, és a megosztási linkek leállnak.',
        button: 'Archiválás',
      },
      active: {
        title: 'Projekt visszaállítása',
        text: 'A projekt újra aktív lesz. A korábbi aktív megosztási linkek ismét működni fognak.',
        button: 'Visszaállítás',
      },
      deleted: {
        title: 'Projekt törlése',
        text: 'A projekt eltűnik a tagok elől, a megosztási linkek leállnak. Később visszaállítható.',
        button: 'Törlés',
      },
    },
    statusChanged: {
      active: 'Projekt visszaállítva',
      archived: 'Projekt archiválva',
      deleted: 'Projekt törölve',
    },
  },
  releases: {
    timeline: 'Kiadások időrendben',
    new: 'Új kiadás',
    newDescription: 'A projekt tagjai e-mailben értesítést kapnak.',
    version: 'Verzió',
    title: 'Cím',
    titlePlaceholder: 'pl. Hibajavítások a szinkronizálásban',
    notes: 'Változások',
    notesHint: 'Mit tartalmaz ez a verzió? A tagok és a megosztási oldal látogatói is látják.',
    file: 'Fájl',
    dropFile: 'Húzza ide a fájlt',
    orBrowse: 'vagy kattintson a tallózáshoz',
    changeFile: 'kattintson a cseréhez',
    fileRequired: 'Válasszon ki egy fájlt.',
    publish: 'Közzététel',
    uploading: 'Feltöltés… {progress}%',
    published: 'v{version} közzétéve',
    publishFailed: 'A feltöltés nem sikerült. Ellenőrizze a kapcsolatot, és próbálja újra.',
    notifying: 'Értesítők küldése…',
    notified: 'Értesítők elküldve',
    notifyFailed: 'Az értesítő e-mailek nem mentek ki.',
    notifyPartial: '{sent} értesítő kiment, {failed} címre nem sikerült elküldeni.',
    notifyOnEdit: 'Értesítés küldése a tagoknak a változásról',
    resend: 'Értesítés újraküldése',
    resendTitle: 'Értesítés újraküldése',
    resendConfirm: 'A projekt tagjai és az adminok újra e-mailt kapnak a(z) v{version} kiadásról.',
    resendButton: 'Küldés',
    latest: 'Legújabb',
    download: 'Letöltés',
    downloadStarted: 'A letöltés elindult',
    downloadFailed: 'A letöltés nem sikerült. Próbálja újra.',
    downloadLog: 'Letöltési napló',
    edit: 'Kiadás szerkesztése',
    saved: 'Kiadás mentve',
    saveFailed: 'A mentés nem sikerült. Próbálja újra.',
    delete: 'Törlés',
    deleteTitle: 'Kiadás törlése',
    deleteConfirm: 'A(z) v{version} – {title} kiadás és a fájlja véglegesen törlődik. A letöltési napló megmarad.',
    deleted: 'Kiadás törölve',
    deleteFailed: 'A törlés nem sikerült.',
    showMore: 'Teljes leírás',
    showLess: 'Kevesebb',
    empty: 'Még nincs kiadás',
    emptyManager: 'Töltse fel az első verziót; a tagok e-mailben értesítést kapnak.',
    emptyMember: 'Amint a tulajdonos feltölt egy verziót, itt letöltheti.',
  },
  members: {
    explainer:
      'A tagok látják és letölthetik a kiadásokat. Hozzáadáskor a címük felkerül a meghívottak közé, így be tudnak lépni.',
    add: 'Tag hozzáadása',
    addDescription: 'A címre meghívó e-mail megy. Google-fiókkal azonnal, más címmel jelszó beállítása után léphet be.',
    addAndInvite: 'Hozzáadás és meghívás',
    name: 'Név',
    email: 'E-mail cím',
    invalidEmail: 'Adjon meg érvényes e-mail címet.',
    alreadyMember: 'Ez a cím már tagja a projektnek.',
    added: '{name} hozzáadva',
    addFailed: 'A tag hozzáadása nem sikerült.',
    sendingInvite: 'Meghívó küldése…',
    inviteSent: 'Meghívó elküldve: {email}',
    inviteFailed: 'A meghívó e-mail nem ment ki.',
    empty: 'Még nincs tag',
    emptyText: 'Adja hozzá azokat, akiknek le kell tölteniük a kiadásokat.',
    addedOn: 'hozzáadva {date}',
    roles: {
      owner: 'Tulajdonos',
      member: 'Tag',
    },
    remove: '{name} eltávolítása',
    removeTitle: 'Tag eltávolítása',
    removeConfirm: '{name} nem fogja látni ezt a projektet. Más projektekhez való hozzáférése nem változik.',
    removeButton: 'Eltávolítás',
    removed: '{name} eltávolítva',
    removeFailed: 'Az eltávolítás nem sikerült.',
  },
  share: {
    explainer:
      'Külsős partnereknek szóló link. Letöltés előtt meg kell adniuk a nevüket, e-mail címüket és telefonszámukat.',
    create: 'Új link',
    createText: 'Az új link a projekt összes kiadását elérhetővé teszi. Üresen hagyva nincs korlát.',
    createAndCopy: 'Létrehozás és másolás',
    created: 'Link létrehozva',
    createFailed: 'A link létrehozása nem sikerült.',
    validDays: 'Érvényesség (nap)',
    maxDownloads: 'Legfeljebb ennyi letöltés',
    optional: 'Nem kötelező',
    empty: 'Nincs megosztási link',
    emptyText: 'Hozzon létre egyet, ha fiók nélküli partnernek kell átadnia egy buildet.',
    copy: 'Másolás',
    copied: 'Link a vágólapon',
    copyFailed: 'A másolás nem sikerült. Jelölje ki és másolja kézzel.',
    visitors: 'Letöltők',
    deactivate: 'Link leállítása',
    deactivateTitle: 'Link leállítása',
    deactivateConfirm: 'A link azonnal megszűnik működni. A letöltési napló megmarad.',
    deactivated: 'Link leállítva',
    meta: 'Létrehozva {created} — {count} letöltés',
    limit: 'legfeljebb {max}',
    expires: 'lejár {date}',
    state: {
      ok: 'Aktív',
      inactive: 'Leállítva',
      expired: 'Lejárt',
      limitReached: 'Elfogyott',
      notFound: 'Nem található',
    },
    visitorsTitle: 'Letöltők a linken keresztül',
    visitorsText: 'A látogatók által megadott adatok.',
    visitorsEmpty: 'Ezen a linken még senki nem töltött le.',
    contact: 'Elérhetőség',
  },
  downloads: {
    title: 'Letöltési napló',
    onlyYours: 'Csak a saját letöltéseit látja.',
    who: 'Ki',
    what: 'Mit',
    when: 'Mikor',
    ip: 'IP-cím',
    certificate: 'Igazolás',
    empty: 'Még nincs letöltés',
    emptyText: 'Minden letöltés ide kerül, igazolással együtt.',
    loadFailed: 'A napló betöltése nem sikerült.',
    total: 'Összesen {count} letöltés',
  },
  public: {
    sharedWithYou: 'Megosztottak Önnel',
    formTitle: 'Adatai a letöltéshez',
    formText: 'A feltöltő látja, ki töltötte le a fájlt. Az adatokat csak erre használjuk.',
    name: 'Teljes név',
    email: 'E-mail cím',
    phone: 'Telefonszám',
    invalidEmail: 'Adjon meg érvényes e-mail címet.',
    continue: 'Tovább a letöltésekhez',
    available: 'Elérhető verziók',
    changeDetails: 'Adatok módosítása',
    noReleases: 'Ebben a projektben még nincs letölthető verzió.',
    limitReached: 'Ez a link elérte a letöltési korlátot vagy lejárt.',
    unavailableTitle: 'Ez a link nem elérhető',
    unavailable: {
      notFound: 'A link hibás vagy már nem létezik. Kérjen új linket attól, aki küldte.',
      inactive: 'A feltöltő leállította ezt a linket. Kérjen újat attól, aki küldte.',
      expired: 'A link lejárt. Kérjen újat attól, aki küldte.',
      limitReached: 'A link elérte a letöltési korlátot. Kérjen újat attól, aki küldte.',
      error: 'A link betöltése nem sikerült. Frissítse az oldalt.',
    },
    privacy: 'A letöltést az AppTransfer naplózza a feltöltő számára.',
  },
  settings: {
    title: 'Beállítások',
    profile: 'Profil',
    language: 'Nyelv',
    languageText: 'A felület és a dátumok nyelve.',
    theme: 'Téma',
    themeText: 'Világos vagy sötét megjelenés ezen az eszközön.',
  },
  common: {
    loading: 'Betöltés…',
    working: 'Folyamatban…',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    close: 'Bezárás',
    edit: 'Szerkesztés',
    saveChanges: 'Változások mentése',
    retry: 'Újra',
    admin: 'Admin',
    genericError: 'Valami nem sikerült. Próbálja újra.',
  },
};
